import type { Layout } from '../types/types';

const withoutSignedUrlParameters = (url: string | undefined): string => {
  if (!url) return '';

  try {
    const parsed = new URL(url, globalThis.location?.origin ?? 'http://localhost');
    return `${parsed.origin}${parsed.pathname}`;
  } catch {
    return url.split(/[?#]/, 1)[0];
  }
};

/**
 * Identifies the persisted layout asset without including short-lived signed
 * URL parameters. Refreshing a signed URL must not reset an active editor.
 */
export const getLayoutAssetKey = (layout: Layout | null | undefined): string => {
  if (!layout) return '';

  const isPdf = Boolean(layout.has_pdf || layout.pdf_file_id || layout.pdf_page_id);
  const assetUrl = isPdf
    ? layout.pdf_file_url
    : layout.image_url || layout.signed_photo_url || layout.photo_url;

  return JSON.stringify({
    id: String(layout.id),
    kind: isPdf ? 'pdf' : assetUrl ? 'image' : 'empty',
    assetId: isPdf ? layout.pdf_file_id || layout.pdf_page_id || null : null,
    assetPath: withoutSignedUrlParameters(assetUrl),
    pageNumber: isPdf ? (layout.pdf_page_number ?? 1) : null,
    cropRegion: isPdf ? (layout.pdf_crop_region ?? null) : null,
    flippedHorizontal: Boolean(layout.flipped_horizontal),
    flippedVertical: Boolean(layout.flipped_vertical),
  });
};
